<app-home></app-home>
<!-- <app-carousel></app-carousel>
<app-modal></app-modal> -->

<footer>
    <div class="container flex-center" style="margin-bottom: 30px;" fxLayout="column">
        <div>Made with Angular.</div>
        <br>Background image by <a href="https://www.deviantart.com/tacosauceninja"
            style="padding-left: 5px;">TacoSauceNinja</a>
    </div>
</footer>

<router-outlet></router-outlet>